import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'ads',
  name: fr.title,
  description: fr.description,
  icon: 'grid',
  color: '#BE185D',
  glyph: [{ d: 'M4 9h5l10-5v16L9 15H4z' }, { d: 'M8 15v5h4l-2-4' }],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: { uses: ['app.records.read', 'app.records.write'], defines: [] },
  entities: {
    uses: [],
    owns: ['campaigns', 'runs', 'reports', 'history', 'receipts'].map((table) => ({
      table,
      scope: 'workspace' as const,
      description: fr.description,
    })),
  },
  events: {
    emits: emitsOf(events),
    subscribes: [],
  },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  missions: { actions: ['ads.seed'], conditions: ['ads.completed'], blocks: [] },
  migrations: { schema: 'app_ads', dir: 'migrations' },
});
